import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@mui/material';
import BaseField from './BaseField';

/**
 * CheckboxField component for workflow forms.
 * Extends the BaseField with checkbox functionality.
 */
const CheckboxField = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  required,
  error,
  helperText,
  disabled,
  fullWidth,
  className,
  ...rest
}) => {
  // Handle checkbox change
  const handleChange = (e) => {
    onChange({
      target: {
        name,
        value: e.target.checked,
      },
    });
  };

  return (
    <BaseField
      id={id}
      name={name}
      required={required}
      error={error}
      helperText={helperText}
      disabled={disabled}
      fullWidth={fullWidth}
      className={className}
    >
      <FormControlLabel
        control={
          <Checkbox
            id={id}
            name={name}
            checked={Boolean(value)}
            onChange={handleChange}
            onBlur={onBlur}
            disabled={disabled}
            color="primary"
            {...rest}
          />
        }
        label={label}
      />
    </BaseField>
  );
};

CheckboxField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
};

CheckboxField.defaultProps = {
  required: false,
  disabled: false,
  fullWidth: true,
  value: false,
};

export default CheckboxField;
